var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsIconLongterm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15857_4918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.125 42H7.875C3.52538 42 0 38.4746 0 34.125V7.875C0 3.52538 3.52538 0 7.875 0H34.125C38.4746 0 42 3.52538 42 7.875V34.125C42 38.4746 38.4746 42 34.125 42Z",
    fill: "#6C7DE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 21C11.75 15.8914 15.8914 11.75 21 11.75C26.1086 11.75 30.25 15.8914 30.25 21C30.25 26.1086 26.1086 30.25 21 30.25C15.8914 30.25 11.75 26.1086 11.75 21ZM21 10.25C15.0629 10.25 10.25 15.0629 10.25 21C10.25 26.9371 15.0629 31.75 21 31.75C26.9371 31.75 31.75 26.9371 31.75 21C31.75 15.0629 26.9371 10.25 21 10.25ZM21 14.25C20.5858 14.25 20.25 14.5858 20.25 15V19.1454C19.517 19.4421 19 20.1607 19 21C19 22.1046 19.8954 23 21 23C22.1046 23 23 22.1046 23 21C23 20.1607 22.483 19.4421 21.75 19.1454V15C21.75 14.5858 21.4142 14.25 21 14.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15857_4918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsIconLongterm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights_icon_longterm.c426785b02fada69b5989ab418126490.svg";